export default __webpack_public_path__ + "04f1d8728b781908558c8f1442c665ed.svg";